// extracted by mini-css-extract-plugin
module.exports = {"root":"Logging_root__7frJ1","ui":"Logging_ui__kN4J9","label":"Logging_label__e3jqQ","header":"Logging_header__YOgp5","user":"Logging_user__Is7Cl","line":"Logging_line__78f6r"};